export const APPLICATION_STATUS = {
  ALL: 'ALL',
  DD_IN_PROGRESS: 'DD_IN_PROGRESS',
  PROCESSING_BGC: 'PROCESSING_BGC',
  PROCESSING_MATCH: 'PROCESSING_MATCH',
  WAITING_REVIEW: 'WAITING_REVIEW',
  PROCESSED: 'PROCESSED',
  EXPIRED: 'EXPIRED',
}

export const APPLICATION_STATUS_MESSAGES = {
  DD_IN_PROGRESS: 'Due Diligence em andamento',
  PROCESSING_BGC: 'Processando Background Check',
  PROCESSING_MATCH: 'Processando Match',
  WAITING_REVIEW: 'Aguardando análise',
  PROCESSED: 'Concluída',
  EXPIRED: 'Expirada',
}

export const APPLICATION_STATUS_FILTERS = {
  ALL: 'Todas',
  DD_IN_PROGRESS: 'Due Diligence em andamento',
  PROCESSING_BGC: 'Processando Background Check',
  WAITING_REVIEW: 'Aguardando análise',
  PROCESSING_MATCH: 'Processando Match',
  PROCESSED: 'Concluídas',
  EXPIRED: 'Expiradas',
}

export const APPLICATION_RESULT = {
  ALL: 'ALL',
  APPROVED: 'APPROVED',
  REPROVED: 'REPROVED',
}

export const APPLICATION_RESULT_MESSAGES = {
  APPROVED: 'Aprovada',
  REPROVED: 'Reprovada',
}

export const APPLICATION_RESULT_FILTERS = {
  ALL: 'Todas',
  APPROVED: 'Aprovadas',
  REPROVED: 'Reprovadas',
}

export const REVIEW_ACTIONS = {
  APPROVED: 'APPROVED',
  REPROVED: 'REPROVED',
  FORWARDED: 'FORWARDED',
}

export const REVIEW_ACTIONS_MESSAGES = {
  APPROVED: 'aprovar',
  REPROVED: 'reprovar',
  FORWARDED: 'transferir',
}

export const REVIEW_STATUS_MESSAGES = {
  APPROVED: 'Aprovado',
  REPROVED: 'Reprovado',
  FORWARDED: 'Transferido',
}

export const REVIEW_RESULT = {
  APPROVED: "APPROVED",
  REPROVED: "REPROVED",
  ALL: "ALL",
}

export const REVIEW_SEARCH_RESULT_MESSAGES = {
  APPROVED: 'Aprovado',
  REPROVED: 'Reprovado',
  ALL: "Todos",
}

export const REVIEW_STATUS = {
  AWAITING_DECISION: 'AWAITING_DECISION',
  REVIEWED: 'REVIEWED',
  SUSPENDED: 'SUSPENDED',
  PENDING_PROSPECT_FEEDBACK: 'PENDING_PROSPECT_FEEDBACK',
  ALL: 'ALL',
}

export const REVIEW_SEARCH_STATUS_MESSAGES = {
  AWAITING_DECISION: 'Pendentes',
  REVIEWED: 'Finalizados',
  SUSPENDED: 'Suspensos',
  PENDING_PROSPECT_FEEDBACK: 'Aguardando feedback do assessor',
  ALL: 'Todos',
}

export const PROCESS_STATUS = {
  PROCESSING: 'PROCESSING',
  PROCESSED: 'PROCESSED',
  ERROR: 'ERROR',
  ALL: 'ALL',
}

export const PROCESS_STATUS_MESSAGES = {
  PROCESSING: 'Processando',
  PROCESSED: 'Concluído',
  ERROR: 'Erro',
  ALL: 'Todos',
}

export const BGC_APPLICATION_LINKAGE_STATUS = {
  LINKED: 'LINKED',
  UNLINKED: 'UNLINKED',
  ALL: 'ALL',
}
export const BGC_APPLICATION_LINKAGE_STATUS_MESSAGES = {
  LINKED: 'Vinculados',
  UNLINKED: 'Não vinculados',
  ALL: 'Todos',
}

export const USER_ROLE_VALUES = {
  ANALYST: 'Analyst',
  SUPERVISOR: 'Supervisor',
  MANAGER: 'Manager',
  ADMIN: 'Admin',
}

export const USER_ROLE_LABELS = {
  ANALYST: 'Analista (Nível 1)',
  SUPERVISOR: 'Supervisor (Nível 2)',
  MANAGER: 'Gestor (Nível 3)',
  ADMIN: 'Admin (Apenas Leitura)',
}

export const USER_STATUS = {
  ACTIVE: 'active',
  DISABLED: 'disabled',
  ALL: 'ALL',
}

export const USER_STATUS_LABELS = {
  ACTIVE: 'Ativos',
  DISABLED: 'Inativos',
  ALL: 'Todos',
}

export const USER_ROLES_DESCRIPTIONS = {
  Admin:
    'Pode ver as análises manuais, mas não pode tomar decisões. Pode fazer ajustes nas config. administrativas.',
  Analyst:
    'Pode ver as análises manuais, aprovar/reprovar ou encaminhar para a análise de um Supervisor. Não tem acesso às config. administrativas.',
  Supervisor:
    'Pode ver as análises manuais, aprovar/reprovar ou encaminhar para a análise de um Gestor. Não tem acesso às config. administrativas.',
  Manager:
    'Pode ver as análises manuais e tomar decisões. Pode fazer ajustes nas config. administrativas.',
}
